import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式

const whiteList = ['/','/home','/login','/404'] // 不重定向白名单
router.beforeEach(async (to, from, next) => {
  NProgress.start();
  if (whiteList.indexOf(to.path) !== -1) {
    next();
  } else if (!store.getters.token) {
    next('/login')
  } else {
    if(!store.getters.userInfo.id){
      await store.dispatch('GetInfo');
    }
    next()
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})
